<script>
	import {createEventDispatcher,onMount} from 'svelte'
	import {API,http_headers,SPINNER} from '../global.js'
	export let filtro = {}
	let expandido = false
	let _filtro = JSON.parse(JSON.stringify(filtro))

	const dispatch = createEventDispatcher()

	let loading = false
	let idhotel = filtro.idhotel
	let idejecutivo = filtro.idejecutivo

	function aplicar(){
		filtro = JSON.parse(JSON.stringify(_filtro))
		expandido = false
		dispatch('refresh')
	} 

	function resetear(){
		expandido = false
	}

	function set_hotel(){
		filtro.idhotel=idhotel
		dispatch('refresh')	
	}

	function set_ejecutivo(){
		filtro.idejecutivo=idejecutivo
		dispatch('refresh')	
	}

	const getEjecutivos = async () => {
		loading=true
		let rs = await fetch(`${API}/usuarios?activo=1&rpp=9999`)
		let ds = await rs.json()
		//console.log(ds)
		loading=false
		return ds || []

	}

</script>



	<button class="btn btn-primary" on:click={()=>expandido=true}>
		<i class="bi-funnel"></i>
	</button>
	{#await getEjecutivos()}
		<p>Loading.....</p>
		{:then ejecutivos}
			<select class="" bind:value={idejecutivo} on:change={set_ejecutivo}>
			  	<option value="0">TODOS</option>
			  	{#each ejecutivos.data as ejecutivo, index}
			  		<option value="{ejecutivo.idgescom}">{ejecutivo.username}</option>
			  	{/each}
			</select>
	{/await}

	<select bind:value={idhotel} on:change={set_hotel}>
		<option value="0">Todos</option>
		<option value="1">RDA</option>
		<option value="2">RDE</option>
	</select>

{#if expandido}
	<div class="container position-absolute top-30 start-20 m-4 border border-secondary rounded bg-light p-4" style="z-index:2000;">
		<div class="row mb-3">
			<div class="col-2">CAM Anteriores</div>
			<div class="col-8">
				<select name="" id="" bind:value={_filtro.anterior}>
					<option value="">No Importa</option>
					<option value="(c.saldo_sub_3Qc.saldo_sub_2Qc.saldo_sub_1)<10">Sin deuda</option>
					<option value="(c.saldo_sub_3Qc.saldo_sub_2Qc.saldo_sub_1)>=10">Con deuda</option>
				</select>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-2">CAM Actual</div>
			<div class="col-8">
				<select name="" id="" bind:value={_filtro.actual}>
					<option value="">No Importa</option>
					<option value="(c.saldo_add_0)<10">Sin deuda</option>
					<option value="(c.saldo_add_0)>=10">Con deuda</option>
				</select>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-2">CAM Actual (SFP)</div> 
			<div class="col-8">
				<select name="" id="" bind:value={_filtro.actualsfp}>
					<option value="">No Importa</option>
					<option value="(c.saldosfp_add_0)<10">Sin deuda</option>
					<option value="(c.saldosfp_add_0)>=10">Con deuda</option>
				</select>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-2">CAM Año siguiente</div>
			<div class="col-8">
				<select name="" id="" bind:value={_filtro.siguiente}>
					<option value="">No Importa</option>
					<option value="(c.saldo_add_1)<10">Sin deuda</option>
					<option value="(c.saldo_add_1)>=10">Con deuda</option>
				</select>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-2">Dias sin contacto</div>
			<div class="col-8">
				<select name="" id="" bind:value={_filtro.dsc}>
					<option value="">No Importa</option>
					<option value="(getdate()-cc.lastupdate)<">Menos de</option>
					<option value="(getdate()-cc.lastupdate)>=">Mas de</option>
				</select>
				<input type="" name="" size="2" bind:value={_filtro.cantdias}>
			</div>
		</div>
		<div class="row mb-3 pb-3 border-bottom ">
			<div class="col-2">Estado</div>
			<div class="col-8">
				<span style="background-color: #FFFFFF;" class="rounded px-3 py-1 border">
					<input class="form-check-input" type=checkbox bind:group={_filtro.estados} value={"FFFFFF"} >
				</span>
				<span style="background-color: #00CCFF;" class="rounded px-3 py-1">
					<input class="form-check-input" type=checkbox bind:group={_filtro.estados} value={"00CCFF"} >
				</span>
				<span style="background-color: #CCFF00;" class="rounded px-3 py-1">
					<input class="form-check-input" type=checkbox bind:group={_filtro.estados} value={"CCFF00"} >
				</span>
				<span style="background-color: #FFB300;" class="rounded px-3 py-1">
					<input class="form-check-input" type=checkbox bind:group={_filtro.estados} value={"FFB300"} >
				</span>
				<span style="background-color: #FF00CC;" class="rounded px-3 py-1">
					<input class="form-check-input" type=checkbox bind:group={_filtro.estados} value={"FF00CC"} >
				</span>
			</div>
		</div>
		<div class="float-end">
			<button  class="btn btn-secondary" on:click={resetear}>Cancelar</button>
			<button  class="btn btn-primary" on:click={aplicar}>Aplicar</button>
		</div>
		<!--pre>{JSON.stringify(_filtro,null,2)}</pre-->
	</div>
{/if}